import React from 'react';
import { PaymentMethod } from '~/types/Payment';
import PaymentTab from '../PaymentTab';

const EDCTab = ({
  onSubmit,
}: {
  onSubmit: (params: { method: PaymentMethod; description: string }) => void;
}) => {
  const handleSubmit = (desc: string) => {
    onSubmit({
      method: PaymentMethod.EDC,
      description: desc,
    });
  };
  return <PaymentTab placeholder="Pilih EDC" onSubmit={handleSubmit} />;
};

export default EDCTab;
